var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"toc"}},[_vm._m(0),_c('ul',_vm._l((_vm.sections),function(section){return _c('li',{key:section.id},[(section.name)?_c('RouterLink',{attrs:{"to":{
          name: section.name,
          params: section.params
        }},domProps:{"textContent":_vm._s(section.title)}}):_c('a',{attrs:{"href":`#${section.id}`},domProps:{"textContent":_vm._s(section.text)}})],1)}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v("Table of Contents")])])
}]

export { render, staticRenderFns }